import { retrieveVendorList, setVendorList } from '../actions/advertisingOptionsActions';
import { fetchVendorList } from 'owa-gdpr-ad-consent-string';
import { orchestrator } from 'satcheljs';

export default orchestrator(retrieveVendorList, async actionMessage => {
    let vendorList = await fetchVendorList();

    // We need to de-reference the vendorList of the MobX functions used later with this orchestrator and use a copy in the store
    // The reason is MobX will convert vendorList's properties like vendors to Observable Arrays instead of the arrays
    // When this happens, passing vendorList back to the consent string sdk will not work as Array.isArray(observable([])) will yield false and consent string sdk will treat vendorList as an invalid vendorList
    // It also has the method to use MobX toJS() to convert vendorList back to array-like before passing back to the external library but this needs to be done in every caller
    let vendorListCopy = JSON.parse(JSON.stringify(vendorList));
    setVendorList(vendorListCopy);
});
